import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import { twMergeConfig } from '@/shared/ui/lib/tv';

/**
 * Class merge that knows the design scales (text sizes, radii, shadows, blurs, leading, tracking — spec 01 §8.6),
 * the same config the UI kit's `tv()` uses, so `cn('rounded-8', props.className)` overrides reliably.
 * Write the font size before the line height: `text-13 leading-20`.
 */
const twMerge = extendTailwindMerge(twMergeConfig);

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
